import React from "react";
import { Document, Page, Text, View, StyleSheet,Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
    color: "#101828",
  },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  label: { color: "#344054", fontWeight: "bold" },
  value: { color: "#101828" },
});

const ExportRequestsPDF = ({ data,logo }) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>

    {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}
        <Text style={styles.heading}>
          {t("requestManagement.heading")}
        </Text>

        {data.map((row, index) => (
          <View key={index} style={styles.recordGroup}>

            <View style={styles.row}>
              <Text style={styles.label}>{t("requestManagement.tableHeaders.id")}:</Text>
              <Text style={styles.value}>{row.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("requestManagement.tableHeaders.type")}:</Text>
              <Text style={styles.value}>{row.type}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("requestManagement.tableHeaders.reasonCode")}:</Text>
              <Text style={styles.value}>{row.reasonCode}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("requestManagement.tableHeaders.reason")}:</Text>
              <Text style={styles.value}>{row.reason}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("requestManagement.tableHeaders.date")}:</Text>
              <Text style={styles.value}>{row.date}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("requestManagement.tableHeaders.comments")}:</Text>
              <Text style={styles.value}>{row.comments}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("requestManagement.tableHeaders.status")}:</Text>
              <Text style={styles.value}>{t(`statuses.${row.status}`)}</Text>
            </View>

          </View>
        ))}

      </Page>
    </Document>
  );
};

export default ExportRequestsPDF;
